"use strict";

exports.__esModule = true;
exports.create = create;
exports.default = void 0;
var _schema = _interopRequireDefault(require("./schema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Mixed = _schema.default;
var _default = exports.default = Mixed;
function create() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

create.prototype = Mixed.prototype;